<template>
  <div id="publicClass_success">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="hotgkt_bj">
      <div class="order_Steps">
        <div class="ul">
          <div class="stepsT"><strong><span class="left"></span><span class="right"></span></strong></div>
          <div class="li" :class="{side:side1}">订单确认</div>
          <div class="li" :class="{side:side2}">订单支付</div>
          <div class="li" :class="{side:side3}">购买成功</div>
        </div>
      </div>
      <!-- order_Steps end -->
      <div class="order_content">
        <div class="order_xx">
          <div class="p1"><img src="../../assets/publicClass/pay_success.png" width="120"></div>
          <div class="p2">恭喜您已购买成功！</div>
          <div class="p3">付款金额:￥{{dataText}}</div>
          <div class="p4"><strong>您想继续做：</strong>
            <router-link :to="{path:'/personalCentre/myCoursesB'}">查看订单</router-link>
            <router-link :to="{path:'/personalCentre/myMission2'}">我的课程</router-link>
            <!-- <router-link :to="{path:'/course_list'}">继续购买</router-link> -->
            <a href="javascript:;" @click="goFun()">继续购买</a>

          </div>
        </div>
      </div>
      <!-- order_content end -->
      <div class="tip">
        <p>直播课不支持Windows xp和Mac OS10.11以下版本，需要升级电脑系统后上课！</p>
        <router-link :to="{path:'/downloads?nav=7'}" target="_blank">下载APP 上课更便捷</router-link>
      </div>
      <!-- tip end -->
    </div>
    <!-- hotgkt_bj end -->
  </div>
</template>

<script>
  import Header from '../../components/header/Header.vue'; //公共头部
  export default {
    name: 'App',
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,

    },
    data() {
      return {
        side1: true,
        side2: true,
        side3: true,
        checked: false,
        radio: '',
        radio1: '',
        radio2: '',
        pay_tan: false,
        dataText: ''
      }
    },
    methods: {
      goFun() {
        this.$router.go(-3)
        // location.reload()
      },
      changeD() {
        this.pay_tan = true
        if (this.radio == '1') {
          this.radio1 = true
        } else {
          this.radio1 = false
        }
        if (this.radio == '2') {
          this.radio2 = true
        } else {
          this.radio2 = false
        }
      },
      closePay() {
        // console.log(this.anys)
        this.pay_tan = false
        this.radio = ''
        this.radio1 = false
        this.radio2 = false
      }
    },
    mounted: function() { //自动触发写入的函数
      let that = this
      if (!this.$cookies.isKey("token")) {
        this.$router.push("/index")
      }
      that.dataText = JSON.parse(localStorage.getItem('Money'))
    }
  }
</script>

<style scoped>
  a {
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .bottombox {
    box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
    position: relative;
    z-index: 9;
  }

  .hotgkt_bj {
    background: #FAFAFA;
    padding-top: 20px;
    padding-bottom: 110px;
  }

  .order_Steps {
    width: 1180px;
    height: 120px;
    background: #FFFFFF;
    border-radius: 12px;
    margin: 0 auto;
    margin-bottom: 16px;
  }

  .order_Steps .ul {
    width: 658px;
    height: 77px;
    padding-top: 22px;
    margin: 0 auto;
    display: -webkit-flex;
    justify-content: space-between;
    display: flex;
    position: relative;
  }

  .order_Steps .ul .li {
    display: inline-block;
    width: 110px;
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    color: #999999;
    background: url(../../assets/publicClass/icon_JD-B.png) top no-repeat;
    text-align: center;
    padding-top: 61px;
    position: relative;
    z-index: 5;
  }

  .order_Steps .ul .li.side {
    background-image: url(../../assets/publicClass/icon_JD-A.png);
    color: #333333;
  }

  .order_Steps .ul .stepsT {
    width: 600px;
    height: 5px;
    background: #F6F6F6;
    border-radius: 3px;
    position: absolute;
    left: 29px;
    top: 65px;
    padding-top: 1px;
  }

  .order_Steps .ul .stepsT strong {
    display: block;
    width: 600px;
    height: 4px;
    background: #FF7E7E;
    border-radius: 3px;

  }

  .order_Steps .ul .stepsT strong span {
    width: 6px;
    height: 6px;
    background: #FF7E7E;
    border-radius: 3px;
    margin-top: -1px;
  }

  .order_Steps .ul .stepsT strong .left {
    margin-left: -1px;
  }

  .order_content {
    width: 1180px;
    background: #FFFFFF;
    border-radius: 12px;
    margin: 0 auto;
  }

  .order_xx {
    width: 1080px;
    padding-top: 50px;
    padding-bottom: 90px;
    margin: 0 auto;
    text-align: center;
  }

  .order_xx .p1 {
    margin-bottom: 32px;
  }

  .order_xx .p2 {
    font-size: 14px;
    color: #333;
    line-height: 14px;
    margin-bottom: 16px;
  }

  .order_xx .p3 {
    font-size: 16px;
    color: #666;
    line-height: 16px;
    margin-bottom: 66px;
  }

  .order_xx .p4 {
    text-align: center;
  }

  .order_xx .p4 strong {
    display: inline-block;
    line-height: 28px;
    color: #999;
    margin: 0 6px;
    font-size: 16px;
    font-weight: normal;
  }

  .order_xx .p4 a {
    display: inline-block;
    width: 124px;
    height: 28px;
    background: rgba(248, 248, 248, 1);
    border-radius: 14px;
    line-height: 28px;
    color: #666;
    margin: 0 6px;
    font-size: 16px;
    cursor: pointer;
  }

  .order_xx .p4 a:hover {
    background: rgba(230, 230, 230, 1);
  }

  .order_xx .p4 .goBuy {
    background: linear-gradient(90deg, #7782FB 0%, #4E5CF6 100%);
    color: #FFF;
  }

  .order_xx .p4 .goBuy:hover {
    background: linear-gradient(90deg, #7782FB 0%, #4E5CF6 100%);
    opacity: 0.9;
  }

  .tip {
    width: 1180px;
    margin: 0 auto;
    text-align: right;
  }

  .tip p {
    display: block;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    line-height: 44px;
  }

  .tip a {
    display: inline-block;
    width: 176px;
    height: 36px;
    background: linear-gradient(90deg, #7782FB 0%, #4E5CF6 100%);
    border-radius: 20px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }

  .tip a:hover {
    background: linear-gradient(90deg, #7782FB 0%, #4E5CF6 100%);
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/page2/publicClass/publicClass_success.vue